import { useCallback, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { useLenis } from "@/hooks/useLenis";
import { Preloader } from "@/components/Preloader";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { Prices } from "@/components/Prices";
import { WhyUs } from "@/components/WhyUs";
import { Gallery } from "@/components/Gallery";
import { Testimonials } from "@/components/Testimonials";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { FloatingButtons } from "@/components/FloatingButtons";

export default function Home() {
  useLenis();
  const [ready, setReady] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const onDone = useCallback(() => { setReady(true); setTimeout(() => setShowLoader(false), 1300); }, []);

  return (
    <main data-testid="home-page">
      <AnimatePresence>{showLoader && <Preloader key="preloader" onDone={onDone} />}</AnimatePresence>
      {ready && (
        <>
          <Navbar />
          <Hero />
          <Marquee dark />
          <About />
          <Services />
          <Prices />
          <WhyUs />
          <Gallery />
          <Testimonials />
          <Marquee />
          <Contact />
          <Footer />
          <FloatingButtons />
        </>
      )}
    </main>
  );
}
